<template>
  <div v-if="npc" class="person" :class="`person--${name}`" :style="`--npcwidth: ${npc.Width}px; --npcbottom: ${npc.Bottom}px;`">
    <div v-if="hasSprites" class="person__inner">
      <!-- stand (left) -->
      <img
        v-for="count in 4"
        :key="`ls-${count - 1}`"
        :alt="name"
        :src="npc.LeftStand[count - 1] ? npc.LeftStand[count - 1] : npc.LeftStand[0]"
      >
      <!-- walk (left) -->
      <img
        v-for="count in 4"
        :key="`ls-${count - 1}`"
        :alt="name"
        :src="npc.LeftWalk[count - 1] ? npc.LeftWalk[count - 1] : npc.LeftWalk[0]"
      >
      <!-- stand (right) -->
      <img
        v-for="count in 4"
        :key="`ls-${count - 1}`"
        :alt="name"
        :src="npc.RightStand[count - 1] ? npc.RightStand[count - 1] : npc.RightStand[0]"
      >
      <!-- walk (right) -->
      <img
        v-for="count in 4"
        :key="`ls-${count - 1}`"
        :alt="name"
        :src="npc.RightWalk[count - 1] ? npc.RightWalk[count - 1] : npc.RightWalk[0]"
      >
      <!-- swing (left) -->
      <img
        v-for="count in 4"
        :key="`ls-${count - 1}`"
        :alt="name"
        :src="npc.LeftSwing[count - 1] ? npc.LeftSwing[count - 1] : npc.LeftSwing[0]"
      >
      <!-- swing (right) -->
      <img
        v-for="count in 4"
        :key="`ls-${count - 1}`"
        :alt="name"
        :src="npc.RightSwing[count - 1] ? npc.RightSwing[count - 1] : npc.RightSwing[0]"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'UndergroundNpc2',

  props: {
    npcs: {
      default: () => {},
      type: [Array, Object]
    }
  },

  computed: {
    npc () {
      if (this.npcs) {
        return this.npcs
      }
      return null
    },
    hasSprites () {
      if (this.npc) {
        if (
          this.npc.LeftStand.length > 2 &&
          this.npc.LeftWalk.length > 3 &&
          this.npc.RightStand.length > 2 &&
          this.npc.RightWalk.length > 2 &&
          this.npc.LeftSwing.length > 2 &&
          this.npc.RightSwing.length > 2
        ) {
          return true
        }
      }
      return false
    }
  },

  data () {
    return {
      name: 'npc'
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/mixins.scss';

$delay: 1.1s;
$duration: 7s;
.person--npc {
  display: none;
  bottom: 50px;
  bottom: calc(73px - var(--npcbottom));
  left: 7%;
  width: 0;
  width: var(--npcwidth);
  animation: npc-move $duration linear infinite $delay;

  @include breakpoint(md) {
    display: block;
  }

  .person__inner {
    transform: translate3d(0, 0, 0);
    animation: npc-animate $duration steps(1) infinite $delay;

    img {
      width: var(--npcwidth);
      min-width: var(--npcwidth);
    }
  }
}
@keyframes npc-animate {
  0% {
    transform: translate3d(0, 0, 0);
  }
  3.125% {
    transform: translate3d(calc(var(--npcwidth) * -1), 0, 0);
  }
  6.25% {
    transform: translate3d(calc(var(--npcwidth) * -2), 0, 0);
  }
  9.375% {
    transform: translate3d(calc(var(--npcwidth) * -3), 0, 0);
  }
  12.5% {
    transform: translate3d(0, 0, 0);
  }
  15.625% {
    transform: translate3d(calc(var(--npcwidth) * -1), 0, 0);
  }
  18.75% {
    transform: translate3d(calc(var(--npcwidth) * -2), 0, 0);
  }
  21.875% {
    transform: translate3d(calc(var(--npcwidth) * -3), 0, 0);
  }
  25% {
    transform: translate3d(0, 0, 0);
  }
  28.125% {
    transform: translate3d(calc(var(--npcwidth) * -1), 0, 0);
  }
  31.25% {
    transform: translate3d(calc(var(--npcwidth) * -2), 0, 0);
  }
  34.375% {
    transform: translate3d(calc(var(--npcwidth) * -3), 0, 0);
  }
  37.5% {
    transform: translate3d(calc(var(--npcwidth) * -12), 0, 0);
  }
  40.625% {
    transform: translate3d(calc(var(--npcwidth) * -13), 0, 0);
  }
  43.75% {
    transform: translate3d(calc(var(--npcwidth) * -14), 0, 0);
  }
  46.875% {
    transform: translate3d(calc(var(--npcwidth) * -15), 0, 0);
  }
  50% {
    transform: translate3d(calc(var(--npcwidth) * -20), 0, 0);
  }
  53.125% {
    transform: translate3d(calc(var(--npcwidth) * -21), 0, 0);
  }
  56.25% {
    transform: translate3d(calc(var(--npcwidth) * -22), 0, 0);
  }
  59.375% {
    transform: translate3d(calc(var(--npcwidth) * -23), 0, 0);
  }
  62.5% {
    transform: translate3d(calc(var(--npcwidth) * -8), 0, 0);
  }
  65.625% {
    transform: translate3d(calc(var(--npcwidth) * -9), 0, 0);
  }
  68.75% {
    transform: translate3d(calc(var(--npcwidth) * -10), 0, 0);
  }
  71.875% {
    transform: translate3d(calc(var(--npcwidth) * -11), 0, 0);
  }
  75% {
    transform: translate3d(calc(var(--npcwidth) * -8), 0, 0);
  }
  78.125% {
    transform: translate3d(calc(var(--npcwidth) * -9), 0, 0);
  }
  81.25% {
    transform: translate3d(calc(var(--npcwidth) * -10), 0, 0);
  }
  84.375% {
    transform: translate3d(calc(var(--npcwidth) * -11), 0, 0);
  }
  87.5% {
    transform: translate3d(calc(var(--npcwidth) * -4), 0, 0);
  }
  90.625% {
    transform: translate3d(calc(var(--npcwidth) * -5), 0, 0);
  }
  93.75% {
    transform: translate3d(calc(var(--npcwidth) * -6), 0, 0);
  }
  96.875% {
    transform: translate3d(calc(var(--npcwidth) * -7), 0, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes npc-move {
  12.5% {
    transform: translate3d(0px, 0, 0);
  }
  25% {
    transform: translate3d(0px, 0, 0);
  }
  37.5% {
    transform: translate3d(0px, 0, 0);
  }
  50% {
    transform: translate3d(150px, 0, 0);
  }
  62.5% {
    transform: translate3d(150px, 0, 0);
  }
  75% {
    transform: translate3d(150px, 0, 0);
  }
  87.5% {
    transform: translate3d(150px, 0, 0);
  }
  100% {
    transform: translate3d(0px, 0, 0);
  }
}
</style>
